import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { session } from '../../../services/session';

import {
  ArticleMegatable,
  MerchantMegatable,
  ProductMegatable,
  SmartlinkMegatable,
} from './megatable-extensions';
import { TabbedCards, Tab } from '../../ui/tabs';

import './analytics.scss';

const Analytics = props => {
  return (
    <div className="publisher-analytics">
      <h1>Analytics</h1>
      <TabbedCards styleType="block" fittedUnderline={true} fallbackPath="articles">
        <Tab name="Stories" path="articles" isShowing={true}>
          <ArticleMegatable {...props} />
        </Tab>
        <Tab name="Links" path="smartlinks" isShowing={true}>
          <SmartlinkMegatable {...props} />
        </Tab>
        <Tab name="Merchants" path="merchants" isShowing={true}>
          <MerchantMegatable {...props} />
        </Tab>
        <Tab name="Products Purchased" path="products" isShowing={true}>
          <ProductMegatable {...props} />
        </Tab>
      </TabbedCards>
    </div>
  );
};

export default withRouter(Analytics);
